import { QUERY_KEYS } from 'api/query-keys';
import { useQuery } from 'react-query';
import { SharedApiService } from 'shared/services';

const useGetEnvironmentConfiguration = (enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.environmentConfiguration(),
    queryFn: async () => await SharedApiService.getEnvironmentConfiguration(),
    enabled,
    staleTime: 60_000,
    cacheTime: 60_000,
  });

export { useGetEnvironmentConfiguration };
